// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import selectors from '@/ui/flux/selectors';
import createAssetSourceActivitySelector from '@/ui/flux/tx-log/selectors/asset-source-activity';

const multiAssetSourceActivitySelector =
  selectors.activityTxs.createMultiActivity({
    createAssetSourceActivitySelector,
  });

export default multiAssetSourceActivitySelector;
